import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPrivateMessage as privateMessagesSetup, saveDirectMessageDialogs } from 'store/actions';
import * as QB from 'quickblox/quickblox';
import { showToast } from 'utils'
import { post } from "helpers/api_helper"
import { get } from "helpers/api_helper"

const DialogContext = createContext();

export const useDialogManager = () => useContext(DialogContext);

export const DialogProvider = (
    {
        children,
        activeSection,
        allDialogs,
        createDialogModal,
        setCreateDialogModal,
        directMessageDialogs,
        dialogIdetailsArea,
        setDialogIdetailsArea,
        setAllDialogs,
        selectedChat, setSelectedChat
    }) => {


    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(privateMessagesSetup({ id: -1, values: {} }));
    }, [dispatch]);

    const fileInputRef = useRef(null);
    const dmOusideSetup = useSelector(state => state.PrivateMessage?.privateMessage);
    const dmUserList = useSelector(state => state.Inbox?.directMessageUserMap);
    const dmUserArray = Object.values(dmUserList || {})
    
    function getdUserProfile({ external_id = null, qb_id = null }) {
        let user = null;
        if (external_id) {
            user = dmUserArray.find(user => user?.id === external_id);
        } else if (qb_id) {
            user = dmUserArray.find(user => user?.chat_credentials?.qb_id === qb_id);
        }
        return user?.profile_pic?.file?.url || null;
    }

    const [showButtons, setShowButtons] = useState(false);
    const [view, setView] = useState({ buttonsArea: false, createGroupArea: false, userListArea: false });
    const [userList, setUserList] = useState();
    const [loader, setLoader] = useState(false);
    const [checkedUserIds, setCheckedUserIds] = useState([]);
    const [dialogDetails, setDialogDetails] = useState({ name: null, dialogType: null, image: null });
    const [occupantsList, setOccupantsList] = useState()
    const [userRole, setUserRole] = useState({ role: null, id: null, name: null })
    const [invitePeopleStatus, setinvitePeopleStatus] = useState(false)
    const [newInvitingPeople, setnewInvitingPeople] = useState()
    const [avatarUrl, setAvatarUrl] = useState(null);
    const [loading, setLoading] = useState(false)
    const [selectedMember, setSelectedMember] = useState(null);
    const [userProfile, setUserProfile] = useState(null);

    useEffect(() => {
        if (selectedChat?.type === 3) {
            const fullName = selectedChat?.name?.trim();
            const matchedUser = selectedChat?.userList?.find((user) => {
                const userFullName = `${user?.display_name}`?.trim();
                return userFullName === fullName;
            });
            const member = {
                user: {
                    external_user_id: matchedUser?.id
                }
            };
            getSocialProfileDetails(member);
        }
        return () => {
            setSelectedMember(null);
        };
    }, [selectedChat]);

    const handleProfileClick = (member) => {
        setSelectedMember(member);
        getSocialProfileDetails(member);
    };

    const getSocialProfileDetails = async (member) => {
        const externalUserId = member?.user?.external_user_id;
        if (!externalUserId) {
            showToast("error", "Profile Details Not Found", "Error")
            setUserProfile(null);
            return;
        }
        try {
            const socialProfileDetails = await get(`/user/${member?.user?.external_user_id}`);
            setUserProfile(socialProfileDetails);
            return socialProfileDetails;
        } catch (error) {
            console.error("Error fetching social profile:", error);
        }
    };

    const getFromLocalStorage = (key) => {
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        } catch (error) {
            console.error(`Error parsing JSON from localStorage key "${key}":`, error);
            return null;
        }
    }

    // get User Details From Qb and setting the user details to details area
    const handleFilterUsers = (ids) => {
        const searchParams = { filter: { field: 'external_user_id', param: 'in', value: ids } };
        QB.users.listUsers(searchParams, function (error, result) {
            if (result) setUserList(result?.items?.map(item => item));
            setLoader(false);
        });
    };

    // handling get Users for Each tag from DM outside exp
    const searchAllUsersByTags = async (tags) => {
        setLoader(true);
        const pageLimit = 1000;
        let page = 1;
        let allUsers = [];

        while (true) {
            const result = await new Promise((resolve, reject) => {
                QB.users.get({ tags, page, per_page: pageLimit }, (error, response) => {
                    if (error) reject(error);
                    else resolve(response);
                });
            });

            allUsers = allUsers.concat(result.items || result);
            if (!result.items || result.items.length < pageLimit) break;
            page += 1;
        }

        setLoader(false);
        setUserList(allUsers);
    };

    const dmOutsideExperienceSetup = (dialogSelectionType) => {
        const pmType = dmOusideSetup?.pm_setup_type;
        setDialogDetails(prev => ({
            ...prev,
            dialogType: dialogSelectionType === 'Private' ? 3 : 2
        }));
        if (dialogSelectionType === 'Group') {
            setView({ buttonsArea: false, createGroupArea: true, userListArea: false })
        }
        else {
            setView({ buttonsArea: false, createGroupArea: false, userListArea: true })
        }
        const storedValue = localStorage.getItem('ngStorage-client-config');
        var vendorId = null
        if (storedValue) {
            const parsedValue = JSON.parse(storedValue);
            vendorId = parsedValue.vendor_id;
        }


        if (["users", "tags", "all", "none"].includes(pmType)) {
            switch (pmType) {
                case "users":
                    setLoader(true);
                    const userIds = dmOusideSetup?.pmUsers?.map(user => user?.id);
                    handleFilterUsers(userIds);
                    break;
                case "tags":
                    break;
                case "all":
                    searchAllUsersByTags(["active", `vendorID${vendorId}`]);
                    break;
                case "none":
                    break;
                default:
                    console.warn("Unhandled pm_setup_type:", pmType);
                    break;
            }
        } else {
            console.warn("Unhandled pm_setup_type:", pmType);
        }
    };

    const handleUpdateDilaog = () => {
        var dialogId = selectedChat?._id
        var toUpdateParams = {
            name: dialogDetails?.name
        };



        QB.chat.dialog.update(dialogId, toUpdateParams, (error, updatedDialog) => {
            if (error) {
                console.error('Failed to update dialog:', error);
            } else {
                setCreateDialogModal({ type: null, visible: null })
                setView({ buttonsArea: false, createGroupArea: false, userListArea: false });
                setDialogDetails({ name: null, dialogType: 1 })
                var updatedDmList = {
                    ...directMessageDialogs,
                    items: directMessageDialogs?.items?.map(item => item._id === updatedDialog._id ? { ...item, name: updatedDialog?.name }
                        : item
                    )
                }
                dispatch(saveDirectMessageDialogs(updatedDmList));
                setSelectedChat(prevState => ({
                    ...prevState,
                    name: updatedDialog?.name,
                }));
                sendSytemMessage(3)

            }
        });
    }

    // Access Private Cntent
    const getDialogProfileImage = (uid) => {
        try {
            var fileUID = uid;
            var privateUrl = QB.content.privateUrl(fileUID);
            return privateUrl
        } catch (e) {
            console.warn("Invalid dialog photo UID");
        }
    }

    // Handle Profile image Uploading 
    const handleUploadClick = () => {
        fileInputRef.current.click(); // triggers hidden input
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const params = {
            name: file.name,
            file: file,
            type: file.type,
            size: file.size,
            private: true
        };

        if (dialogDetails?.dialogType === 5) {
            try {
                setLoading(true)
                const updatedDialog = await dialogimageUploading(params);
                setDialogDetails({ ...dialogDetails, image: updatedDialog?.photo });
                var updatedDmList = {
                    ...directMessageDialogs,
                    items: directMessageDialogs?.items?.map(item => item._id === updatedDialog._id ? { ...item, photo: updatedDialog?.photo }
                        : item
                    )
                }
                dispatch(saveDirectMessageDialogs(updatedDmList));
                setSelectedChat(prevState => ({
                    ...prevState,
                    photo: updatedDialog?.photo,
                }));
                setLoading(false)
                sendSytemMessage(5)

            } catch (err) {
                console.error("Error uploading dialog image:", err);
            }
        } else {

            setLoading(true)
            const imageUrl = await dialogimageUploading(params);
            setDialogDetails({ ...dialogDetails, image: imageUrl });
            setLoading(false)
        }


    };

    const dialogimageUploading = (params) => {
        return new Promise((resolve, reject) => {
            QB.content.createAndUpload(params, (error, result) => {
                if (error) {
                    console.error("Upload error:", error);
                    return reject(error);
                }
                const uploadedFileId = result.uid;
                if (dialogDetails?.dialogType === 5) {
                    const dialogId = selectedChat?._id;
                    QB.chat.dialog.update(dialogId, { photo: uploadedFileId }, (err, updatedDialog) => {
                        if (err) {
                            console.error("Dialog update error:", err);
                            return reject(err);
                        } else {

                            return resolve(updatedDialog);
                        }
                    });
                } else {
                    return resolve(uploadedFileId);
                }
            });
        });
    };

    // Create New Dialog
    const handlecreateDialog = async () => {
        const params = {
            type: dialogDetails?.dialogType,
            name: dialogDetails?.name,
            occupants_ids: checkedUserIds,
            data: {
                class_name: "event",
                event_id: -1
            },
            photo: dialogDetails?.image || null
        };

        QB.chat.dialog.create(params, async (error, dialog) => {
            setLoading(true);

            if (error) {
                showToast("error", "Could not create the group");
                setLoading(false);
                return;
            }

            const isPrivate = dialog?.type === 3;

            if (isPrivate) {
                let sourceItems = null;
                let updateFunction = null;

                if (activeSection === 2) {
                    sourceItems = directMessageDialogs?.items || [];
                    updateFunction = function (newItems) {
                        const updatedDmList = { ...directMessageDialogs, items: newItems };
                        dispatch(saveDirectMessageDialogs(updatedDmList));
                    };
                } else {
                    sourceItems = allDialogs || [];
                    updateFunction = function (newItems) {
                        setAllDialogs(newItems);
                    };
                }

                const dialogId = dialog?._id;
                const indexToMove = sourceItems.findIndex(function (item) {
                    return item?._id === dialogId;
                });

                if (indexToMove >= 0) {
                    const newItems = [...sourceItems];
                    const [item] = newItems.splice(indexToMove, 1);
                    newItems.unshift(item);

                    updateFunction(newItems);
                    setSelectedChat(item);
                    stateResetHandler();
                    setLoading(false);
                    return;
                }
            }

            // If it's a new dialog, save and select it
            const newDialog = await createAndSaveNewDialog(dialog);
            setSelectedChat(newDialog);
            stateResetHandler();
            setLoading(false);
        });
    };


    const createAndSaveNewDialog = async (dialog) => {
        const usersDetails = await getUserDetails(dialog?.occupants_ids);
        const formattedUserList = usersDetails?.data || usersDetails;
        const newDialog = {
            ...dialog,
            subTitle: "Direct Message",
            feature_type: 2,
            userList: formattedUserList,
        };
        let tempDmList = { ...directMessageDialogs };
        tempDmList?.items?.unshift(newDialog);
        dispatch(saveDirectMessageDialogs(tempDmList));
        return newDialog;
    };

    const stateResetHandler = () => {
        setCreateDialogModal({ type: null, visible: null });
        setView({ buttonsArea: false, createGroupArea: false, userListArea: false })
        setCheckedUserIds([]);
        setinvitePeopleStatus(false)
        setDialogDetails({ name: "", dialogType: "" });

    }

    const inputHandler = (e) => {
        setDialogDetails(prev => ({ ...prev, name: e.target.value }));
    }

    const getUserDetails = async (occupants_Ids) => {
        const usersList = await post("/get-users", { qb_ids: occupants_Ids })
        return usersList
    }

    const handleupdateOrnextButton = (createDialogModal) => {
        if (createDialogModal === 1) {
            setView({ buttonsArea: false, createGroupArea: false, userListArea: true })
        } else {
            handleUpdateDilaog()
        }
    }

    const modifyDialogAttributes = (params) => {
        const { removedPersonId, action, removedPersonName } = params;
        const dialogId = selectedChat?._id;
        if (!dialogId || !Array.isArray(removedPersonId)) {
            console.error("Invalid dialog ID or occupants_ids");
            return;
        }

        const toUpdateParams = {
            [action]: { occupants_ids: removedPersonId }
        };

        QB.chat.dialog.update(dialogId, toUpdateParams, function (error, dialog) {
            if (error) {
                console.error("Update error:", error);
            } else {
                if (action === "pull_all") {
                    const updatedOccupants = occupantsList?.items?.filter(item => item?.user?.id !== removedPersonId?.[0]);

                    const newData = {
                        ...occupantsList,
                        total_entries: occupantsList.total_entries - 1,
                        items: updatedOccupants
                    };

                    setOccupantsList(newData)
                }
                const updatedSelectedDilaog = getUpdatedSelectedDialog(selectedChat, removedPersonId?.[0])
                setSelectedChat(updatedSelectedDilaog)
                const updatedDialogsData = updateDirectMessageDialogs(directMessageDialogs, updatedSelectedDilaog);
                dispatch(saveDirectMessageDialogs(updatedDialogsData));
                sendSytemMessage(2, removedPersonName)

            }
        });
    };

    function getUpdatedSelectedDialog(dialog, qbIdToRemove) {
        return {
            ...dialog,
            occupants_ids: dialog.occupants_ids?.filter(id => id !== qbIdToRemove),
            userList: dialog.userList?.filter(
                user => user.chat_credentials?.qb_id !== qbIdToRemove
            )
        };
    }

    function updateDirectMessageDialogs(directMessageDialogs, updatedSelectedDilaog) {
        return {
            ...directMessageDialogs,
            items: directMessageDialogs?.items?.map(dialog =>
                dialog._id === updatedSelectedDilaog._id ? updatedSelectedDilaog : dialog
            )
        };
    }

    const sendSytemMessage = (messgeType, personName = null) => {
        const formatNames = (names) => {
            if (Array.isArray(names)) {
                return names.join('\n');
            }
            return names;
        };

        const messageMap = {
            1: () => {
                const names = formatNames(personName);
                return `${userRole?.name} - (group admin) added\n${names}`;
            },
            2: () => `${personName} removed by ${userRole?.name} - (group admin)`,
            3: () => `${userRole?.name} - (group admin) changed the group name to "${dialogDetails?.name}"`,
            4: () => `New group "${dialogDetails?.name}" created by ${userRole?.name}  - (group admin)`,
            5: () => `"${userRole?.name}" - (group admin) The avatar was changed`,
        };

        const content = messageMap[messgeType]?.() || "";
        const message = {
            chat_dialog_id: selectedChat?._id,
            message: content,
            sender_id: selectedChat?.user_id,
            type: 'groupchat',
            save_to_history: 1,
            notification_type: 2,
            date_sent: Math.floor(Date.now() / 1000),
            extension: {
                notification_type: '2'
            }
        };

        QB.chat.message.create(message, function (err, sentMessage) {
            if (err) {
                console.error('Failed to send message:', err);
            } else {
                console.log('Message saved:');
            }
        });

    };

    const existingChekedUser = () => {
        setCheckedUserIds(selectedChat?.occupants_ids)
    }

    const handleAddOccupats = () => {
        let
            dialogId = selectedChat?._id,
            toUpdateParams = {
                push_all: { occupants_ids: checkedUserIds }
            };

        QB.chat.dialog.update(dialogId, toUpdateParams, function (error, dialog) {
            stateResetHandler()
            restrucTuringExistingLits(dialog?.occupants_ids)

        });
    }

    const restrucTuringExistingLits = async (ids) => {
        const filterIds = ids?.filter(id => !newInvitingPeople?.includes(id))
        const newOccupantDetails = await getUserDetails(filterIds)
        const newOccupantNames = newOccupantDetails?.data?.map(item => item.display_name);
        var searchParams = { filter: { field: 'id', param: 'in', value: ids }, page: 1, per_page: 100 };
        QB.users.listUsers(searchParams, async function (error, result) {

            if (result) {
                const newData = {
                    ...occupantsList,
                    total_entries: result?.total_entries,
                    items: result?.items
                };
                setOccupantsList(newData);
                const usersDetails = await getUserDetails(ids);
                const UpdatedSelectedChat = { ...selectedChat, occupants_ids: ids, userList: usersDetails?.data }
                setSelectedChat(UpdatedSelectedChat)
                const updatedDialogsData = updateDirectMessageDialogs(directMessageDialogs, UpdatedSelectedChat);
                dispatch(saveDirectMessageDialogs(updatedDialogsData));
                sendSytemMessage(1, newOccupantNames)
            } else {
                console.log("could not find the users");
            }
        });
    };

    return (
        <DialogContext.Provider
            value={{
                createDialogModal,
                setCreateDialogModal,
                dmOusideSetup,
                view, setView,
                userList, setUserList,
                loader, setLoader,
                checkedUserIds, setCheckedUserIds,
                dialogDetails, setDialogDetails,
                handleFilterUsers,
                searchAllUsersByTags,
                showButtons,
                setShowButtons,
                dmOutsideExperienceSetup,
                dialogIdetailsArea, setDialogIdetailsArea,
                selectedChat, setSelectedChat,
                handleUpdateDilaog,
                directMessageDialogs,
                handlecreateDialog,
                inputHandler,
                handleupdateOrnextButton,
                modifyDialogAttributes,
                occupantsList, setOccupantsList,
                userRole, setUserRole,
                sendSytemMessage,
                invitePeopleStatus, setinvitePeopleStatus,
                existingChekedUser,
                handleAddOccupats,
                stateResetHandler,
                getUserDetails,
                newInvitingPeople, setnewInvitingPeople,
                handleFileChange, handleUploadClick,
                fileInputRef, avatarUrl,
                getDialogProfileImage,
                loading, setLoading,
                getFromLocalStorage,
                selectedMember,
                setSelectedMember,
                userProfile,
                handleProfileClick,
                getdUserProfile

            }}
        >
            {children}
        </DialogContext.Provider>
    );
};
